import React, { Component } from "react";
import "./App.css";

import Sidebar from "./components/Sidebar";
import TopBar from "./components/TopBar";
import Tabs from "./components/Tabs";
import SearchBox from "./components/SearchBox";
import PriceBar from "./components/PriceBar";
import FlightList from "./components/FlightList";

class App extends Component {
  render() {
    return (
      <div className="app-container">
        <Sidebar />

        <div className="main-content">
          <TopBar />
          <Tabs />
          <SearchBox />
          <PriceBar />
          <FlightList />
        </div>
      </div>
    );
  }
}

export default App;
